import { createCollectionReducer, DELETED } from 'ext/lib/collections';
import { TYPE } from './summary-actions';

export default createCollectionReducer(TYPE);

export const selectScreensSummary = state => state[TYPE];
export const selectScreensSummaryList = state =>
  Object.values(selectScreensSummary(state)).filter(screen => !screen[DELETED]);
